import { render } from "./SaveEmployee.vue?vue&type=template&id=67986b19&scoped=true"
import script from "./SaveEmployee.vue?vue&type=script&lang=js"
export * from "./SaveEmployee.vue?vue&type=script&lang=js"

import "./employee.scss?vue&type=style&index=0&id=67986b19&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67986b19"]])

export default __exports__